import Layout from './layout'

export default [
  // app管理
  {
    path: '/appAdminManage',
    component: Layout,
    meta: { groupTitle: '品库后台', roles: ['admin'] },
    hidden:true,
    children: [
      {
        path: '',
        name: 'appAdminManage',
        component: () => import(/* webpackChunkName: "appAdminManage" */ '@v/appAdminManage'),
        meta: { title: 'APP管理', icon: 'app_Manage' },
      },
      {
        path: 'appDetail/:id',
        name: 'appDetail',
        hidden: true,
        component: () => import(/* webpackChunkName: "appAdminManage" */ '@v/appAdminManage/appDetail'),
        meta: {
          title:'app详情',
          icon: 'main',
          showBreadcrumb: true,
        },
      },
    ],
  },
]